import React from 'react'
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import PATH from '../../../router/params';

const PrivateRoutes = ({Component}) => {
  const navigate = useNavigate();
  const isAuthenticated = localStorage.getItem("token");

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(PATH.LOGIN, { replace: true });
    }
  }, []);

  if (!isAuthenticated) return null;
  return (
    <Component/>
  )
}

export default PrivateRoutes